import { render, staticRenderFns } from "./ApprovalResultGranted.vue?vue&type=template&id=590e2dab&scoped=true"
import script from "./ApprovalResultGranted.vue?vue&type=script&lang=js"
export * from "./ApprovalResultGranted.vue?vue&type=script&lang=js"
import style0 from "./ApprovalResultGranted.vue?vue&type=style&index=0&id=590e2dab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590e2dab",
  null
  
)

export default component.exports